import { render, staticRenderFns } from "./MobileNavBar.vue?vue&type=template&id=5c3b6615&scoped=true"
import script from "./MobileNavBar.vue?vue&type=script&lang=js"
export * from "./MobileNavBar.vue?vue&type=script&lang=js"
import style0 from "./MobileNavBar.vue?vue&type=style&index=0&id=5c3b6615&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3b6615",
  null
  
)

export default component.exports